import { useTypedSelector } from '@Features/store';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { FlexLayout } from '@Styled/utilities';
import React, { useState } from 'react';
import styled from 'styled-components';
import StandaloneProgressTable from './StandaloneProgressTable';
import SubscriptionsTable from './SubscriptionsTable';

type Mode = 'enrollment' | 'progress';

/**
 * Student details → Subscriptions: manage what the student holds — bundles
 * (expandable to their courses) and standalone courses (the Courses tab's
 * counterpart). Progress lists the lectures of the held courses. Each view is
 * keyed so a switch remounts it — MainTable/Pagination only refetch on URL
 * changes, never on a swapped handler.
 */
const Subscriptions: React.FC = () => {
	const { currentEntity } = useTypedSelector((state) => state.Students);
	const [mode, setMode] = useState<Mode>('enrollment');
	const studentId: number | undefined = currentEntity?.id;

	if (!studentId) return null;

	return (
		<>
			<Title>Subscriptions</Title>
			<FlexLayout alignItems="center" marginBottom="1.625rem">
				<Toggle value={mode} exclusive onChange={(_, value) => value && setMode(value)}>
					<ToggleItem value="enrollment">Enrollment</ToggleItem>
					<ToggleItem value="progress">Progress</ToggleItem>
				</Toggle>
			</FlexLayout>
			{mode === 'progress' ? (
				<StandaloneProgressTable key="progress" studentId={studentId} />
			) : (
				<SubscriptionsTable key="enrollment" studentId={studentId} />
			)}
		</>
	);
};

const Title = styled.div`
	color: #251b33;
	font-size: 20px;
	font-weight: bold;
	margin-bottom: 35px;
`;
const Toggle = styled(ToggleButtonGroup)`
	align-items: center;
`;
const ToggleItem = styled(ToggleButton)`
	background: #6e7577;
	color: #fff;
	font-size: 0.875rem;
	font-weight: normal;
	height: 2.7rem;
	text-transform: none;

	&:hover {
		background: #6e7577;
		color: #fff;
	}

	&.Mui-selected,
	&.Mui-selected:hover {
		background: #5ac0fc;
		height: 3rem;
		color: #fff;
	}
`;

export default Subscriptions;
